import React from 'react';
import { TextColorMenu } from '../../FontTool/TextColorMenu';
import TextColorIcon from '../../../assets/text-color-tool.png';

interface IColorPickerTool {
  expanded: boolean;
  currentState: {
    color: string;
    bgColor: string;
  };
  onExpandEvent: () => void;
  onChange: (tool: string, value: string) => void;
}

export const ColorPickerTool: React.FC<IColorPickerTool> = props => {
  const { expanded, currentState, onExpandEvent, onChange } = props;

  const isActive = currentState.color;

  const onSelectColor = (event: React.MouseEvent) => {
    const target = event.target as HTMLElement;
    const color = target.getAttribute('color') as string;
    onChange('color', color);
  };

  return (
    <button
      aria-haspopup="true"
      aria-expanded={expanded}
      aria-label="rdw-color-picker"
      title="Color Picker"
      data-testid="color-picker-tool"
      className={`rdw-option-wrapper text-editor-tool ${isActive ? 'rdw-option-active' : ''}`}
      onClick={onExpandEvent}
    >
      <img src={TextColorIcon as string} alt="Text color tool" />
      <TextColorMenu onClick={onSelectColor} isActive={expanded} chosenColor={currentState?.color} x={-80} y={-63} />
    </button>
  );
};
